var pym = require("./lib/pym");
require("./lib/webfonts");
var renderScrolly = require("./scrolly");

var pymChild;
var renderD3Graphic = require("./renderD3Graphic");
var renderKey = require("./renderKey");

// Initialize the graphic.
var onWindowLoaded = function() {
  // you would format data here if you needed to
  // var data = formatData(window.DATA);
  render();

  window.addEventListener("resize", () => render());

  pym.then(child => {
    pymChild = child;
    child.sendHeight();
  });
};

var render = function() {

  var wrapper = document.querySelector("#d3-graphic");
  wrapper.innerHTML = ""; // clear once at the top

  const noNY = window.DATA.filter(item => item.City != 'New Jersey / New York');


  noNY.forEach(function(group, index, array) {
    var container = document.createElement("div");
    if (index === array.length - 1) {
    container.classList.add('ring-container', 'last');
    }
    else{
    container.className = "ring-container";
    }
    wrapper.appendChild(container);

    renderD3Graphic({
      container: container,
      width: 150,
      data: group,
      colorFn: function(value) {

        if (value > 77) {
          return '#ff1d25';
        }
        else if (value >= 72) {
          return '#ffc002';
        }
        else {
          return '#3fa9f5';
        }

      },

    });
  })

  var key = document.querySelector("#topper");
  key.innerHTML = ""; // clear once at the top


  var container_2 = document.createElement("div");
  key.appendChild(container_2);


  const newYork = window.DATA.filter(item => item.City === 'New Jersey / New York');

      renderKey({
      container: container_2,
      width: 250,
      data: newYork,
      colorFn: function(value) {


        if (value > 77) {
          return '#ff1d25';
        }
        else if (value >= 72) {
          return '#ffc002';
        }
        else {
          return '#3fa9f5';
        }

      },

    });




  // // Render the chart!
  // var container = "#d3-graphic";
  // var element = document.querySelector(container);
  // var width = element.offsetWidth / 3;
  // var bigData = window.DATA;

  // for (let index = 0; index < bigData.length; index++) {
  //   const data = bigData[index];

  //   renderD3Graphic({
  //     container,
  //     width,
  //     data
  //   });

    
  // }


  // Update iframe
  if (pymChild) {
    pymChild.sendHeight();
  }
};

// Initially load the graphic
// wait for images to load. see: https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
window.addEventListener("load", onWindowLoaded);

